import {DependencyList, memo, useEffect, useRef} from 'react'
import {useAsyncEffect} from 'ahooks'
import initOpenAppSDK from '@/plugins/initOpenAppSDK'
import {useUaParam} from '@/pages/_app'
import {IS_CLIENT} from '@/constants/env'
import {niceTry} from '@/utils'
import {haboClickReport} from '@/plugins/habo'
import {LoginSchemeProps} from '@/pages/video/[mediaID]'
import {parse} from 'cookie'

const styles = require('./style.module.less')

interface IOpenAppWrapProps {
    className?: string;
    children: React.ReactNode;
    link?: string;
    appName?: AppName;
    actionType?: string;
    schemeParams?: IReportInfo;
    loginSchemeParams?: LoginSchemeProps;
    deps?: DependencyList;
}

let onceAutoOpen = false

const OpenAppWrap = (props: IOpenAppWrapProps) => {
    const defaultUrl = IS_CLIENT ? `${location.href}&page_source=1&pageSource=1` : ''
    const {
        children,
        link = defaultUrl,
        className,
        appName,
        actionType,
        schemeParams = {},
        deps = [],
        loginSchemeParams,
    } = props
    const mainProps = {
        page_source: 1,
        pageSource: 1,
        ...actionType
            ? {action_type: actionType}
            : {link, category: 'web'},
    }
    // 增加全局的isApp, 这样就无需根据环境来判断是否使用该包裹组件了
    const wrap = useRef<HTMLDivElement>(null)
    const {
        fromWeChat,
        isApp,
        schemeOtherProps = '{}',
    } = useUaParam()
    useAsyncEffect(async () => {
        if (isApp) {
            return
        }
        const openAppSdk = require('@gaotu/open-app-sdk')
        let resolved = await Promise.resolve(schemeParams)
        if (loginSchemeParams?.need_login) {
            resolved = {...resolved, ...loginSchemeParams}
        }
        // 微信打开了浏览器尝试自动打开app
        if (fromWeChat && !onceAutoOpen) {
            onceAutoOpen = true
            const otherProps = niceTry(() => JSON.parse(decodeURIComponent(schemeOtherProps))) || {}
            openAppSdk.openOrDownloadAppNew({...mainProps, ...resolved, ...otherProps})
            haboClickReport('下载高途APP的入口点击', resolved)
        }
        const openParams:IObject = {...mainProps, ...resolved}
        openParams.business_type = 'tushu'
        openAppSdk.bindElement(wrap.current!, openParams)
    }, [
        link,
        ...deps,
        loginSchemeParams,
    ])

    if (isApp) {
        return (
            <>
                {children}
            </>
        )
    }
    return (
        <div
            ref={wrap}
            className={className || styles.wrap}
        >
            {children}
        </div>
    )
}

export default memo(OpenAppWrap)
